import React, { useState } from "react";
import PropTypes from "prop-types";
import "./privatePolicy.scss";
import { RouterConfig } from "../../../../config";
import { NavLink, useNavigate } from "react-router-dom";

const data = [
    {
        id: 1, title: 'Giới thiệu',
        text:
            <>
                <div>Khi sử dụng dịch vụ của chúng tôi, bạn tin tưởng chia sẻ thông tin của bạn cho chúng tôi. Chúng tôi hiểu rằng đây là một trách nhiệm lớn và chúng tôi nỗ lực bảo vệ thông tin của bạn cũng như để bạn nắm quyền kiểm soát. </div>
                <div>Chính sách bảo mật này nhằm mục đích giúp bạn hiểu rõ những thông tin chúng tôi thu thập, lý do chúng tôi thu thập và cách bạn có thể cập nhật, quản lý, xuất và xóa thông tin của mình.</div>
                <div>Chính sách này có hiệu lực từ 01 tháng 01 năm 2022.</div>
                <div>Chúng tôi phát triển các dịch vụ liên quan đến bản đồ để tích hợp vào các ứng dụng của bên thứ ba.</div>
                <div>Bạn có thể sử dụng các dịch vụ của chúng tôi theo nhiều cách khác nhau để quản lý quyền riêng tư của mình.</div>
                <div>Để giúp giải thích mọi điều rõ ràng nhất, chúng tôi đã thêm các ví dụ hay hình ảnh/ video minh họa và cung cấp các định nghĩa cho các thuật ngữ riêng mà chúng tôi sử dụng trong dịch vụ của mình.</div>
                <div>Ngoài các chính sách này, bạn cũng cần quan tâm đến <NavLink to={RouterConfig.rules.route}>Điều khoản dịch vụ Map4D</NavLink> để đảm bảo rằng bạn không bỏ lỡ các thông tin quan trọng liên quan đến trách nhiệm của chúng tôi và của bạn trong khi bạn sử dụng dịch vụ do chúng tôi cung cấp.</div>
            </>
    }
    ,
    {
        id: 2, title: 'Thông tin Map4D thu thập',
        text:
            <>
                <div>Chúng tôi muốn bạn hiểu rõ các loại thông tin mà chúng tôi thu thập khi bạn sử dụng dịch vụ của chúng tôi </div>
                <div> Chúng tôi thu thập thông tin để cung cấp các dịch vụ tốt hơn cho tất cả người dùng của mình. Ví dụ: chúng tôi thu thập các từ khóa mà người dùng
                    thường xuyên tìm kiếm để hiểu rõ hơn nhu cầu thực tế của người dùng, từ đó chúng tôi xây dựng các tính năng
                    tối ưu hơn. Thông tin mà Map4D thu thập và cách thông tin đó được sử dụng tùy thuộc vào cách bạn dùng các dịch vụ của chúng tôi cũng như cách bạn quản lý các tùy chọn kiểm soát quyền riêng tư của mình.</div>
            </>
    },
    {
        id: 4, title: 'Những thông tin bạn tạo hoặc cung cấp cho chúng tôi',
        text:
            <>
                <div>Khi bạn tạo một tài khoản trên hệ thống Map4D, bạn cung cấp cho chúng tôi thông tin cá nhân bao gồm email, mật khẩu của bạn, ngoài ra bạn có thể cung cấp thêm các thông tin như họ tên của bạn, số điện thoại của bạn, tỉnh thành phố mà bạn đang sống. Bạn cũng có thể tạo một tài khoản trên hệ thống Map4D thông qua tài khoản có sẵn trên một số nền tảng khác. Chúng tôi chỉ sử dụng các thông tin này khi được sự cho phép của bạn.</div>
                <div>
                Khi bạn đăng nhập trên Map4D thông qua bên thứ ba, chúng tôi sử dụng id của bạn mà bên thứ 3 cung cấp để đăng nhập vào hệ thống Map4D, chúng tôi cũng sử dụng tài khoản email của bạn đã đăng ký với bên thứ ba để gửi các email thông báo từ hệ thống Map4D vào tài khoản email của bạn
                </div>
                <div> Chúng tôi thu thập các thông tin mà bạn tạo, tải lên khi bạn sử dụng các tính năng trên hệ thống Map4D, bao gồm: Tạo một địa điểm trên Map4D, yêu cầu chỉnh sửa một số thông tin của một địa điểm trên hệ thống Map4D, lưu địa điểm trên Map4D...</div>
            </>
    },
    {
        id: 5, title: 'Thông tin chúng tôi thu thập khi bạn sử dụng các dịch vụ của chúng tôi',
        text:
            <>
                <div>Các trình duyệt và thiết bị của bạn</div>

                <div> Chúng tôi thu thập thông tin về các ứng dụng, trình duyệt và thiết bị mà bạn dùng để truy cập vào dịch vụ của Map4D. Điều này giúp chúng tôi cung cấp các tính năng như tự động cập nhật sản phẩm.</div>

                <div>Thông tin chúng tôi thu thập gồm loại trình duyệt và thông tin về thiết bị mà bạn đang sử dụng.</div>

                <div>Chúng tôi thu thập thông tin này  khi một dịch vụ của Map4D trên thiết bị của bạn kết nối với máy chủ của chúng tôi. Ví dụ: khi bạn truy cập vào hệ thống Map4D và sử dụng các tính năng trên hệ thống Map4D.</div>

                <div>Thông tin này sẽ không được chia sẻ cho bất cứ ai ngoài mục đích cải thiện trải nghiệm người dùng.</div>
            </>
    },
    {
        id: 6, title: 'Thông tin về vị trí của bạn',
        text:
            <>
                <div>Chúng tôi thu thập thông tin về vị trí của bạn khi bạn sử dụng các dịch vụ của chúng tôi. Điều này giúp chúng tôi cung cấp những tính 
                    năng như thông tin chỉ đường lái xe, kết quả tìm kiếm về những địa điểm gần bạn dựa trên vị trí khái quát của bạn.</div>
                <div>Chúng tôi có thể xác định vị trí của bạn với độ chính xác khác nhau bằng:</div>
                <div><div className="indentation">- Dữ liệu GPS</div></div>
                <div><div className="indentation">- Địa chỉ IP </div></div>
                <div> Hoạt động trên các dịch vụ của Map4D, chẳng hạn như nội dung bạn tìm kiếm và những địa điểm bạn gắn nhãn là nhà riêng hoặc cơ quan.</div>
                <div>Các loại dữ liệu vị trí chúng tôi thu thập và thời gian chúng tôi lưu trữ sẽ tuỳ thuộc một phần vào thiết bị và các chế độ cài đặt tài khoản của bạn. </div>
            </>
    },
    {
        id: 7, title: 'Lý do Map4D thu thập dữ liệu ',
        text:
            <>
                <div> Chúng tôi sử dụng dữ liệu để phát triển các dịch vụ tốt hơn.</div>
                <div><b>Cung cấp dịch vụ: </b> Chúng tôi sử dụng các thông tin của bạn để cung cấp các dịch vụ như xử lý các cụm từ mà bạn tìm kiếm để trả về kết quả tối ưu hơn cho bạn.</div>
                <div><b>Duy trì và cải thiện dịch vụ của chúng tôi:</b> Chúng tôi cũng sử dụng thông tin của bạn để đảm bảo các dịch vụ của chúng tôi hoạt động như
                    dự tính, chẳng hạn như cung cấp dịch vụ dẫn đường chính xác hơn cho bạn. Ngoài ra, chúng tôi còn dùng thông tin của bạn để cải tiến các dịch vụ của mình.
                    Ví dụ: việc hiểu cụm từ tìm kiếm nào được sử dụng nhiều nhất giúp chúng tôi biết được thói quen của bạn để đưa ra những gợi ý tốt hơn cho bạn.</div>
                <div>
                    <b> Đo lường hiệu quả: </b>Chúng tôi dùng dữ liệu để phân tích và đo lường nhằm hiểu rõ cách các dịch vụ của chúng tôi được sử dụng. Ví dụ: chúng tôi phân tích dữ liệu
                    về các lần bạn truy cập vào các trang web của chúng tôi để làm những việc như tối ưu hoá thiết kế sản phẩm.
                </div>
                <div>
                    <b>Liên lạc với bạn: </b>Chúng tôi sử dụng thông tin thu thập được, chẳng hạn như địa chỉ email của bạn, để tương tác trực tiếp với bạn. Ví dụ: chúng tôi có thể gửi cho bạn thông báo nếu phát hiện
                    thấy hoạt động đáng ngờ hoặc bất thường đối với tài khoản của bạn trên hệ thống Map4D. Ngoài ra, chúng tôi có thể thông báo cho bạn biết về các thay đổi hoặc cải tiến sắp tới đối với dịch vụ của chúng tôi.
                </div>
                <div>
                    <b>Bảo vệ Map4D, người dùng Map4D và các bên liên quan: </b>Chúng tôi sử dụng thông tin để giúp cải thiện độ an toàn và tin cậy cho các dịch vụ của mình. Điều này bao gồm việc phát hiện, ngăn chặn và
                    ứng phó với những hành vi gian lận, lạm dụng, các rủi ro về bảo mật và vấn đề kỹ thuật có thể có hại cho Map4D, người dùng của Map4D hoặc các bên liên quan.
                </div>
                <div>Chúng tôi sẽ xin phép bạn trước khi sử dụng thông tin của bạn cho một mục đích không được đề cập đến trong Chính sách này. </div>
            </>
    },
    {
        id: 8, title: 'Chia sẻ thông tin của bạn',
        text:
            <>
                <div> Map4D sẽ không chia sẻ thông tin cá nhân của bạn với các công ty, tổ chức hoặc cá nhân bên ngoài Map4D.</div>
            </>
    },
    {
        id: 9, title: 'Bảo mật thông tin của bạn',
        text:
            <>
                <div>Chúng tôi tích hợp tính năng bảo mật vào các dịch vụ để bảo vệ thông tin của bạn .</div>
                <div>Tất cả các dịch vụ của Map4D đều được tích hợp các tính năng bảo mật mạnh mẽ, liên tục bảo vệ thông tin của bạn. Thông tin chi tiết chúng tôi có được từ việc duy trì các dịch vụ giúp chúng tôi phát hiện và tự động chặn các mối đe dọa về bảo mật để chúng không bao giờ tiếp cận được đến bạn. Nếu phát hiện thấy điều gì đó có khả năng gây rủi ro mà chúng tôi cho là bạn nên biết, chúng tôi sẽ thông báo cho bạn và hướng dẫn bạn thực hiện các bước để được bảo vệ tốt hơn.</div>
                <div>Chúng tôi nỗ lực bảo vệ bạn và Map4D khỏi hành vi truy cập trái phép, thay đổi, tiết lộ hoặc phá hủy thông tin chúng tôi nắm giữ, bao gồm:</div>
                <div> <div className="indentation">- Chúng tôi sử dụng biện pháp mã hóa để bảo mật dữ liệu của bạn trong khi truyền. </div></div>
                <div> <div className="indentation">- Chúng tôi xem xét các cách thức xử lý, lưu trữ và thu thập thông tin, bao gồm cả các biện pháp bảo mật vật lý, để ngăn hành vi truy cập trái phép vào các hệ thống của mình. </div></div>
                <div> <div className="indentation">- Chúng tôi chỉ cho phép các nhân viên và người đại diện của Map4D truy cập vào thông tin cá nhân, họ là những người cần thông tin đó để xử lý thông tin. Bất cứ ai có quyền truy cập này đều phải thực hiện các nghĩa vụ bảo mật nghiêm ngặt theo hợp đồng và có thể bị kỷ luật hoặc chấm dứt hợp đồng nếu họ không tuân theo các nghĩa vụ đó.</div></div>
            </>
    },
    {
        id: 10, title: 'Xóa tài khoản',
        text:
            <>
                <div>Bạn có quyền xóa tài khoản của mình trên Map4D.</div>
                <div>Khi bạn xác nhận xóa tài khoản của bạn trên Map4D, tài khoản của bạn sẽ bị xóa vĩnh viễn khỏi hệ thống Map4D, đồng thời bạn sẽ không thể khôi phục được bất kỳ thông tin nào trên Map4D đối với tài khoản mà bạn đã xóa.</div>
                <div>Map4D chỉ cho phép bạn xóa tài khoản khi bạn đã thực hiện đầy đủ nghĩa vụ thanh toán hóa đơn (trường hợp tài khoản của bạn có sử dụng dịch vụ của Map4D và phát sinh hóa đơn)</div>
            </>
    },
    {
        id: 11, title: 'Bảo mật thông tin của bạn',
        text:
            <>
                <div>Chúng tôi tích hợp tính năng bảo mật vào các dịch vụ để bảo vệ thông tin của bạn .</div>
                <div>Tất cả các dịch vụ của Map4D đều được tích hợp các tính năng bảo mật mạnh mẽ, liên tục bảo vệ thông tin của bạn. Thông tin chi tiết chúng tôi có được từ việc duy trì các dịch vụ giúp chúng tôi phát hiện và tự động chặn các mối đe dọa về bảo mật để chúng không bao giờ tiếp cận được đến bạn. Nếu phát hiện thấy điều gì đó có khả năng gây rủi ro mà chúng tôi cho là bạn nên biết, chúng tôi sẽ thông báo cho bạn và hướng dẫn bạn thực hiện các bước để được bảo vệ tốt hơn.</div>
                <div>Chúng tôi nỗ lực bảo vệ bạn và Map4D khỏi hành vi truy cập trái phép, thay đổi, tiết lộ hoặc phá hủy thông tin chúng tôi nắm giữ, bao gồm:</div>
                <div> <div className="indentation">- Chúng tôi sử dụng biện pháp mã hóa để bảo mật dữ liệu của bạn trong khi truyền. </div></div>
                <div> <div className="indentation">- Chúng tôi xem xét các cách thức xử lý, lưu trữ và thu thập thông tin, bao gồm cả các biện pháp bảo mật vật lý, để ngăn hành vi truy cập trái phép vào các hệ thống của mình. </div></div>
                <div> <div className="indentation">- Chúng tôi chỉ cho phép các nhân viên và người đại diện của Map4D truy cập vào thông tin cá nhân, họ là những người cần thông tin đó để xử lý thông tin. Bất cứ ai có quyền truy cập này đều phải thực hiện các nghĩa vụ bảo mật nghiêm ngặt theo hợp đồng và có thể bị kỷ luật hoặc chấm dứt hợp đồng nếu họ không tuân theo các nghĩa vụ đó.</div></div>
            </>
    },

]
const PrivatePolicy = () => {
    return (
        <div className='privatePolicy'>
            {
                data.map((value, index) => {
                    return (
                        <React.Fragment key={value.id}>
                            <div className='titContent'>{value.title}</div>
                            <div className="text">
                                {value.text}
                            </div>
                        </React.Fragment>
                    )
                })
            }
        </div>
    );
};

PrivatePolicy.propTypes = {
};

export default PrivatePolicy;
